// A-share convention: red = up/profit, green = down/loss
export const upColor = 'text-[#ea2261]';
export const downColor = 'text-[#15be53]';
export const upBg = 'bg-[#ea2261]';
export const downBg = 'bg-[#15be53]';
export const upBorder = 'border-[#ea2261]';
export const downBorder = 'border-[#15be53]';

export function changeColorClass(isUp: boolean) {
  return isUp ? upColor : downColor;
}

export function changeBgClass(isUp: boolean) {
  return isUp ? upBg : downBg;
}

export function pnlColorClass(isProfit: boolean) {
  return isProfit ? upColor : downColor;
}
